import FileSaver from 'file-saver'
import { Configuration } from '@cesdk/cesdk-js'

import { useImgly } from '../utils'
import { useIsStore } from '../../../auth/utils'

type Props = {
  config?: Omit<Configuration, 'callbacks'>
  initialScene?: string | null
  onSave: NonNullable<Configuration['callbacks']>['onSave']
}

function ImglyEditor({ config, initialScene, onSave }: Props) {
  const { isOneShop } = useIsStore()

  const { ref } = useImgly({
    config: {
      ...config,
      callbacks: {
        onDownload: 'download',
        onExport(blobs) {
          FileSaver.saveAs(blobs[0], 'OneShop')
        },
        onLoad: 'upload',
        onSave,
      },

      ui: {
        elements: {
          navigation: {
            action: {
              download: isOneShop(),
              load: { show: isOneShop() },
              save: true,
              export: { show: true, format: ['image/png'] },
            },
          },
        },
      },
    },
    initialScene,
  })

  return <div className="absolute inset-0" ref={ref} />
}

export { ImglyEditor }
